module.exports = __webpack_public_path__ + "static/media/t_rim.ea05c2fc.png";